// extracted by css-extract-rspack-plugin
export default {"wrap":"UpdateEntity_wrap__3Wwpk","icon":"UpdateEntity_icon__J4kCQ","mobile":"UpdateEntity_mobile__PC145"};